import { Lightning } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  Lightning,
  React
};